module.exports = __webpack_public_path__ + "img/active-skill-star.4b0b1cae.svg";